import { useState, useCallback, useEffect } from 'react';
import QRCode from 'qrcode';
import './ToolStyles.css';

const QrcodeGenerator = () => {
    const [text, setText] = useState('');
    const [dataUrl, setDataUrl] = useState('');
    const [error, setError] = useState('');

    const generate = useCallback(async () => {
        setError('');
        if (!text.trim()) {
            setDataUrl('');
            return;
        }
        try {
            const url = await QRCode.toDataURL(text.trim(), {
                width: 300,
                margin: 2,
                color: { dark: '#000000', light: '#ffffff' },
            });
            setDataUrl(url);
        } catch {
            setError('二维码生成失败，请检查输入内容');
            setDataUrl('');
        }
    }, [text]);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (text.trim()) generate();
        }, 300);
        return () => clearTimeout(timer);
    }, [text, generate]);

    return (
        <div className="tool-container">
            <div className="input-group">
                <label className="input-label">输入文本或网址</label>
                <textarea
                    className="tool-textarea"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    rows={3}
                    placeholder="输入要生成二维码的文本或 URL..."
                />
            </div>

            <button className="tool-button primary" onClick={generate}>
                生成二维码
            </button>

            {error && <div className="error-message">{error}</div>}

            {dataUrl && (
                <div className="output-group" style={{ textAlign: 'center' }}>
                    <label className="output-label">二维码</label>
                    <div style={{
                        padding: 20, backgroundColor: '#fff', borderRadius: 16,
                        display: 'inline-block', border: '1px solid var(--border-color)',
                    }}>
                        <img src={dataUrl} alt="二维码" style={{ display: 'block', maxWidth: '100%' }} />
                    </div>
                    <button
                        className="tool-button"
                        style={{ marginTop: 12 }}
                        onClick={() => {
                            const link = document.createElement('a');
                            link.download = 'qrcode.png';
                            link.href = dataUrl;
                            link.click();
                        }}
                    >
                        下载图片
                    </button>
                </div>
            )}
        </div>
    );
};

export default QrcodeGenerator;
